export const educationData = [
    {
        id: 1,
        institution: 'Cantonment Public School & College',
        course: 'Secondary School Certificate',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 2,
        institution: 'Notre Dame College',
        course: 'Higher Secondary Certificate',
        startYear: '2015',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'Daffodil International University',
        course: 'Bsc In CSE',
        startYear: '2018',
        endYear: 'Present'
    },
]